// extracted by mini-css-extract-plugin
export default {"carouselImg":"CarouselImages_carouselImg__ZuvzE"};